function handleBasicScrollObserver(entries, observer) {
	entries.forEach((entry) => {
		if (entry.isIntersecting && entry.target.classList.contains("u-watch")) {
			entry.target.classList.add("u-watch--active");
		} else {
			entry.target.classList.remove("u-watch--active");
		}
	});
}

function handleOutScrollObserver(entries) {
	entries.forEach((entry) => {
		if (!entry.isIntersecting && entry.boundingClientRect.top <= 0) {
			entry.target.classList.add("u-watch--active-out");
		} else {
			entry.target.classList.remove("u-watch--active-out");
		}
	});
}

function handleLazyLoadImages(entries, observer) {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			let imgEle = entry.target;

			// WP Rocket lazyload replaces src with an SVG placeholder and stores the
			// real URL in data-lazy-src. Use data-lazy-src when present, fall back to src.
			let imageUrl = imgEle.getAttribute("data-lazy-src") || imgEle.getAttribute("src");

			if (imageUrl) {
				// Restore <source> srcset in parent <picture> if WP Rocket modified them
				const picture = imgEle.closest("picture");
				if (picture) {
					picture.querySelectorAll("source[data-lazy-srcset]").forEach(function (source) {
						source.setAttribute("srcset", source.getAttribute("data-lazy-srcset"));
						source.removeAttribute("data-lazy-srcset");
					});
				}

				// Restore img srcset if WP Rocket modified it
				const lazySrcset = imgEle.getAttribute("data-lazy-srcset");
				if (lazySrcset) {
					imgEle.setAttribute("srcset", lazySrcset);
					imgEle.removeAttribute("data-lazy-srcset");
				}

				imgEle.src = imageUrl;
				imgEle.removeAttribute("data-lazy-src");

				if (imgEle.complete) {
					imgEle.classList.add("lazy-image--loaded");
				} else {
					imgEle.onload = () => {
						imgEle.classList.add("lazy-image--loaded");
					};
				}

				observer.unobserve(entry.target);
			}
		}
	});
}

export default function scrollRevealInit() {
	const basicScrollObserver = new IntersectionObserver(
		handleBasicScrollObserver,
		{
			root: document.querySelector(".wp-site-blocks"),
			rootMargin: "-25% 0% -25% 0%",
			threshold: 0,
		}
	);

	const lazyImageObserver = new IntersectionObserver(handleLazyLoadImages, {
		threshold: 0.1,
	});

	const watchers = document.querySelectorAll(`.u-watch`);

	if (watchers) {
		[].forEach.call(watchers, (watcher) => {
			basicScrollObserver.observe(watcher);
		});
	}

	// const outWatchers = document.querySelectorAll(`.u-watch--out`);

	// if (outWatchers) {
	//   [].forEach.call(outWatchers, (watcher) => {
	//     outScrollObserver.observe(watcher);
	//   });
	// }

	const imgWatchers = document.querySelectorAll(".lazy-image");
	if (imgWatchers) {
		[].forEach.call(imgWatchers, (watcher) => {
			lazyImageObserver.observe(watcher);
		});
	}
}
